module.exports = __webpack_public_path__ + "assets/images/animations/laus-ribbon.webp?56a53244";